import {
  CreateBrokerageAnniversaryRequest,
  ICreateBrokerageAnniversaryRequest,
} from "../../repsaApi";
import { Dayjs } from "dayjs";
import api from "./financialSettingsApi";
import {
  brokerageAnniversariesLoading,
  brokerageAnniversariesLoaded,
  brokerageAnniversariesError,
  createBrokerageAnniversaryPending,
  createBrokerageAnniversaryFulfilled,
  createBrokerageAnniversaryRejected,
  updateBrokerageAnniversaryPending,
  updateBrokerageAnniversaryFulfilled,
  updateBrokerageAnniversaryRejected,
  deleteBrokerageAnniversaryPending,
  deleteBrokerageAnniversaryFulfilled,
  deleteBrokerageAnniversaryRejected,
  activeBrokerageAnniversaryLoading,
  activeBrokerageAnniversaryLoaded,
  activeBrokerageAnniversaryError,
} from "./financialSettingsStateActions";
import { IBrokerageAnniversaryModel } from "../../../types/types";

export function getBrokerageAnniversaries() {
  return function (dispatch: any) {
    dispatch(brokerageAnniversariesLoading());
    api.getBrokerageAnniversaries().then(
      (data: IBrokerageAnniversaryModel[]) => {
        dispatch(
          brokerageAnniversariesLoaded(
            data.map(
              (d) =>
                ({
                  ...d,
                  anniversaryDate: d.anniversaryDate,
                } as IBrokerageAnniversaryModel)
            )
          )
        );
      },
      (error: Error) => dispatch(brokerageAnniversariesError(error.message))
    );
  };
}

export function createBrokerageAnniversary(
  data: ICreateBrokerageAnniversaryRequest
) {
  var requestData = new CreateBrokerageAnniversaryRequest({ ...data });
  return function (dispatch: any) {
    dispatch(createBrokerageAnniversaryPending());
    return api.createBrokerageAnniversary(requestData).then(
      (result: IBrokerageAnniversaryModel) => {
        const action = createBrokerageAnniversaryFulfilled(result);
        dispatch(action);
        return action;
      },
      (error: Error) => {
        let errorMessage = error.message;
        if (
          errorMessage.includes("duplicate") ||
          errorMessage.toLowerCase().includes("already exists")
        ) {
          errorMessage =
            "An anniversary with this date already exists. Please choose a different date.";
        }
        const action = createBrokerageAnniversaryRejected(errorMessage);
        dispatch(action);
        return { error: action };
      }
    );
  };
}

export function updateBrokerageAnniversary(
  id: number,
  data: ICreateBrokerageAnniversaryRequest
) {
  var requestData = new CreateBrokerageAnniversaryRequest({ ...data });
  return function (dispatch: any) {
    dispatch(updateBrokerageAnniversaryPending(id));
    return api.updateBrokerageAnniversary(id, requestData).then(
      (result: IBrokerageAnniversaryModel) => {
        const action = updateBrokerageAnniversaryFulfilled(result);
        dispatch(action);
        return action;
      },
      (error: Error) => {
        let errorMessage = error.message;
        if (
          errorMessage.includes("duplicate") ||
          errorMessage.toLowerCase().includes("already exists")
        ) {
          errorMessage =
            "An anniversary with this date already exists. Please choose a different date.";
        }
        const action = updateBrokerageAnniversaryRejected(errorMessage);
        dispatch(action);
        return { error: action };
      }
    );
  };
}

export function deleteBrokerageAnniversary(id: number) {
  return function (dispatch: any) {
    dispatch(deleteBrokerageAnniversaryPending(id));
    api.deleteBrokerageAnniversary(id).then(
      () => dispatch(deleteBrokerageAnniversaryFulfilled(id)),
      (error: Error) =>
        dispatch(deleteBrokerageAnniversaryRejected(error.message))
    );
  };
}

export function getActiveBrokerageAnniversaryForDate(date: Dayjs) {
  return function (dispatch: any) {
    dispatch(activeBrokerageAnniversaryLoading());
    api.getActiveBrokerageAnniversaryForDate(date).then(
      (data: IBrokerageAnniversaryModel) =>
        dispatch(activeBrokerageAnniversaryLoaded(data)),
      (error: Error) => dispatch(activeBrokerageAnniversaryError(error.message))
    );
  };
}
